import { render, staticRenderFns } from "./paramsJsonSchemaView.vue?vue&type=template&id=870cca6c&"
import script from "./paramsJsonSchemaView.vue?vue&type=script&lang=js&"
export * from "./paramsJsonSchemaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports